<template><div><h1 id="_5-jobs" tabindex="-1"><a class="header-anchor" href="#_5-jobs"><span>5. Jobs</span></a></h1>
<h2 id="_5-1-jobs" tabindex="-1"><a class="header-anchor" href="#_5-1-jobs"><span>5.1. Jobs</span></a></h2>
<p>Aufgegebene Jobs werden rechts unten in funtrade, sobald sie fertig sind, mit einem Symbol eingeblendet.</p>
<p><img src="@source/manual/user/i/5_jobs.png" alt="Jobs"></p>
<p>Beim betätigen des Icons wird ein Fenster mit den eigenen Jobs angezeigt. Aus der Liste kann dann der Inhalt des gewünschten Jobs angezeigt oder auch gespeichert werden. Nach der Betätigung des Icons erlischt das Symbol, die Jobs können jedoch jederzeit über <code v-pre>Datei → Jobs</code> aufgerufen werden.</p>
<p><img src="@source/manual/user/i/5_jobs2.png" alt="Jobübersicht"></p>
</div></template>


